import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorStateService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ngx-translate/core';

function ErrorsComponent_div_0_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, error_r2));
} }
function ErrorsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, ErrorsComponent_div_0_p_1_Template, 3, 3, "p", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.errorService.errors);
} }
class ErrorsComponent {
    constructor(errorService) {
        this.errorService = errorService;
    }
    ngOnInit() { }
}
ErrorsComponent.ɵfac = function ErrorsComponent_Factory(t) { return new (t || ErrorsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ErrorStateService)); };
ErrorsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ErrorsComponent, selectors: [["fgbcl-errors"]], decls: 1, vars: 1, consts: [["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"], [4, "ngFor", "ngForOf"]], template: function ErrorsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ErrorsComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorService.hasErrors());
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], pipes: [ɵngcc3.TranslatePipe], styles: [""] });
ErrorsComponent.ctorParameters = () => [
    { type: ErrorStateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-errors',
                template: "<div *ngIf=\"errorService.hasErrors()\" class=\"alert alert-danger\">\r\n  <p *ngFor=\"let error of errorService.errors\">{{ error | translate }}</p>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.ErrorStateService }]; }, null); })();

class ErrorsModule {
}
ErrorsModule.ɵfac = function ErrorsModule_Factory(t) { return new (t || ErrorsModule)(); };
ErrorsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ErrorsModule });
ErrorsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ErrorsModule, { declarations: function () { return [ErrorsComponent]; }, imports: function () { return [CommonModule, ɵngcc3.TranslateModule]; }, exports: function () { return [ErrorsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorsModule, [{
        type: NgModule,
        args: [{
                declarations: [ErrorsComponent],
                imports: [
                    CommonModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [ErrorsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorsComponent, ErrorsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-errors.js.map